import { render, staticRenderFns } from "./AnnounceList.vue?vue&type=template&id=573fe2d0&scoped=true&"
import script from "./AnnounceList.vue?vue&type=script&lang=js&"
export * from "./AnnounceList.vue?vue&type=script&lang=js&"
import style0 from "./AnnounceList.vue?vue&type=style&index=0&id=573fe2d0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573fe2d0",
  null
  
)

export default component.exports